(function () {
  const LEGACY_BIS_ENDPOINT = 'https://a.klaviyo.com/api/v1/catalog/subscribe';
  const KLAVIYO_PUBLIC_KEY = 'S24cMh';
  const MODERN_BIS_ENDPOINT = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${encodeURIComponent(KLAVIYO_PUBLIC_KEY)}`;
  const KLAVIYO_REVISION = '2026-07-15';

  if (!window.__sssBisKlaviyoBridgeInstalled) {
    window.__sssBisKlaviyoBridgeInstalled = true;
    const nativeFetch = window.fetch.bind(window);
    window.fetch = async function (input, init) {
      const requestUrl = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      if (!requestUrl.startsWith(LEGACY_BIS_ENDPOINT)) return nativeFetch(input, init);

      try {
        const legacyBody = init && init.body ? init.body : '';
        const params = legacyBody instanceof URLSearchParams ? legacyBody : new URLSearchParams(String(legacyBody || ''));
        const email = String(params.get('email') || '').trim();
        const variantId = String(params.get('variant') || '').trim();

        if (!email || !/^\d+$/.test(variantId)) {
          return new Response(JSON.stringify({ success: false }), {
            status: 400,
            headers: { 'Content-Type': 'application/json' }
          });
        }

        const modernPayload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        };

        const response = await nativeFetch(MODERN_BIS_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json',
            'revision': KLAVIYO_REVISION
          },
          body: JSON.stringify(modernPayload)
        });

        if (response.ok) {
          return new Response(JSON.stringify({ success: true }), {
            status: 200,
            headers: { 'Content-Type': 'application/json' }
          });
        }

        const failureText = await response.clone().text().catch(() => '');
        console.error('[SSS BIS] Klaviyo subscription failed', response.status, failureText);
        return new Response(JSON.stringify({ success: false }), {
          status: response.status || 400,
          headers: { 'Content-Type': 'application/json' }
        });
      } catch (error) {
        console.error('[SSS BIS] Klaviyo bridge error', error);
        return new Response(JSON.stringify({ success: false }), {
          status: 500,
          headers: { 'Content-Type': 'application/json' }
        });
      }
    };
  }

  const current = document.currentScript;
  const currentSrc = current && current.src ? current.src : '';
  const baseSrc = currentSrc.replace(/main-product\.js(?=\?|$)/, 'main-product-bis-base-sep16.js');

  const addCompactStyles = () => {
    if (document.getElementById('sss-bis-compact-styles')) return;
    const style = document.createElement('style');
    style.id = 'sss-bis-compact-styles';
    style.textContent = `
      .sss-bis-sizes.sss-bis-sizes--compact{margin:10px 0 2px!important;padding:0!important;border-top:0!important}
      .sss-bis-sizes--compact details{border-top:1px solid rgba(17,17,17,.12);border-bottom:1px solid rgba(17,17,17,.12)}
      .sss-bis-sizes--compact summary{list-style:none;display:flex;align-items:center;justify-content:space-between;gap:14px;min-height:44px;padding:11px 0;cursor:pointer;color:#171717;font:600 12px/1.35 Lato,sans-serif}
      .sss-bis-sizes--compact summary::-webkit-details-marker{display:none}
      .sss-bis-sizes--compact .sss-bis-compact__summary-copy{display:flex;align-items:baseline;gap:8px;min-width:0}
      .sss-bis-sizes--compact .sss-bis-compact__label{font-weight:600}
      .sss-bis-sizes--compact .sss-bis-compact__action{font-weight:400;color:#6a655f;text-decoration:underline;text-underline-offset:2px;white-space:nowrap}
      .sss-bis-sizes--compact .sss-bis-compact__chevron{width:8px;height:8px;border-right:1px solid #171717;border-bottom:1px solid #171717;transform:rotate(45deg);transition:transform .18s ease;margin-right:3px;flex:0 0 auto}
      .sss-bis-sizes--compact details[open] .sss-bis-compact__chevron{transform:rotate(225deg);margin-top:5px}
      .sss-bis-sizes--compact .sss-bis-compact__body{padding:1px 0 13px}
      .sss-bis-sizes--compact .sss-bis-sizes__title{display:none!important}
      .sss-bis-sizes--compact .sss-bis-sizes__copy{margin:0 0 10px!important;font:400 12px/1.45 Lato,sans-serif!important;color:#66615b!important}
      .sss-bis-sizes--compact .sss-bis-sizes__list{gap:7px!important}
      .sss-bis-sizes--compact .sss-bis-size{min-width:46px!important;padding:8px 10px!important;font-size:12px!important}
      @media(max-width:749px){
        .sss-bis-sizes.sss-bis-sizes--compact{margin-top:8px!important}
        .sss-bis-sizes--compact summary{min-height:42px;padding:10px 0}
        .sss-bis-sizes--compact .sss-bis-compact__summary-copy{gap:6px;flex-wrap:wrap}
      }
    `;
    document.head.appendChild(style);
  };

  const compactify = (module) => {
    if (!module || module.dataset.sssBisCompact === 'true') return;
    const copy = module.querySelector('.sss-bis-sizes__copy');
    const list = module.querySelector('[data-sss-bis-list]');
    if (!copy || !list) return;

    module.dataset.sssBisCompact = 'true';
    module.classList.add('sss-bis-sizes--compact');

    const details = document.createElement('details');
    details.className = 'sss-bis-compact__details';

    const summary = document.createElement('summary');
    summary.innerHTML = '<span class="sss-bis-compact__summary-copy"><span class="sss-bis-compact__label">Sold out in your size?</span><span class="sss-bis-compact__action">Get notified</span></span><span class="sss-bis-compact__chevron" aria-hidden="true"></span>';

    const body = document.createElement('div');
    body.className = 'sss-bis-compact__body';
    copy.textContent = 'Choose a sold-out size and we’ll email you when it’s back.';

    body.appendChild(copy);
    body.appendChild(list);
    details.appendChild(summary);
    details.appendChild(body);

    const title = module.querySelector('.sss-bis-sizes__title');
    if (title) title.remove();
    module.appendChild(details);

    const root = module.closest('[data-sss-pdp-master]');
    if (root) {
      root.addEventListener('change', function (event) {
        if (event.target.closest('variant-radios,variant-selects')) details.open = false;
      }, true);
    }
  };

  const applyCompactLayer = () => {
    addCompactStyles();
    document.querySelectorAll('[data-sss-bis-sizes]').forEach(compactify);
  };

  const startObserver = () => {
    applyCompactLayer();
    const observer = new MutationObserver(() => applyCompactLayer());
    observer.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => setTimeout(applyCompactLayer, 0));
  };

  if (!baseSrc || baseSrc === currentSrc) {
    startObserver();
    return;
  }

  const base = document.createElement('script');
  base.src = baseSrc;
  base.async = false;
  base.onload = startObserver;
  base.onerror = startObserver;
  (document.head || document.documentElement).appendChild(base);
})();
